import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import utc from 'dayjs/plugin/utc';
import relativeTime from 'dayjs/plugin/relativeTime';
import isoWeek from 'dayjs/plugin/isoWeek';

export default defineNuxtPlugin(() => {
  dayjs.extend(utc);
  dayjs.extend(relativeTime);
  dayjs.extend(isoWeek);
  dayjs.locale('fr');
});
